import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { HeaderService } from '../../services/header.service';

@Component({
  selector: 'app-not-found-component',
  templateUrl: './not-found.component.html'
})
export class NotFoundComponent {
  constructor(
    private title: Title,
    private translate: TranslateService,
    private headerService: HeaderService) {
  }

  ngOnInit() {
    this.translate.get('Pages.NotFound.Title').subscribe((res: string) => {
      this.title.setTitle(res);
      this.headerService.setPageTitle(false, 0, res);
    });
  }
}
